import React from 'react';

import { NotFoundPage } from 'gatsby-theme-localized';

import Seo from '../components/SEO';

import { NotFound } from '../modules/not-found-page';
import { usePageViewEvent } from '../utils/hooks/usePageViewEvent';

import * as Constants from '../constants';

const CustomNotFound = ({ pageContext, location, setLocale }) => {
    usePageViewEvent('page_not_found');

    return (
        <NotFoundPage {...{ pageContext, location, setLocale }}>
            <Seo pageId={Constants.pages.NOT_FOUND} />
            <NotFound />
        </NotFoundPage>
    );
};

export default CustomNotFound;
